export const initialState = {
    GrowthCharts: {
        ChildData: {
            Sex: null,
            BirthDate: null,
            BirthDateYYYY: null,
            BirthDateMM: null,
            BirthDateDD: null,
            AgeToday: null,
            CompleteAgeToday: null,
            FatherHeight: null,
            MotherHeight: null,
            TargetHeight: null,
            Title: null,
            Comment: null,
            Measures: [],
        },
        Data: null,
    },
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'GROWTHCHART_UPDATE':
            return {
                ...state,
                ...action,
            };
        case 'GROWTHCHART_RESET':
            return {
                ...initialState,
            };
        default:
            return state;
    }
};
